import { render, staticRenderFns } from "./FormOtherPersonalInfo.vue?vue&type=template&id=206401a0"
import script from "./FormOtherPersonalInfo.vue?vue&type=script&lang=js"
export * from "./FormOtherPersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./FormOtherPersonalInfo.vue?vue&type=style&index=0&id=206401a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports